var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UtteranceControl',_vm._g({attrs:{"content":_vm.content,"isLoading":_vm.isLoading,"disabled-enter":_vm.portalDisabled},on:{"disabledEnter":_vm.handleMessage}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }